export const closeOnOutsideClickMixin = {
  methods: {
    listenForOutsideClicks() {
      document.addEventListener('click', this.closeOnOutsideClick);
    },

    stopListeningForOutsideClicks() {
      document.removeEventListener('click', this.closeOnOutsideClick);
    },

    closeOnOutsideClick(event) {
      const isOutside =
        this.$refs.container !== event.target &&
        !this.$refs.container.contains(event.target);

      if (isOutside) {
        this.close();
      }
    },
  },
};
